import React from "react"
import FinalAuth from "../components/FirebaseAuth/FinalAuth"
import Layout from "../components/layout/layout"
import SEO from "../components/layout/seo"
import AuthSection from "../components/Sections/AuthSection"

export default function Account() {
  return (
    <Layout>
      <SEO title="Pro Account" favicon="../PM/Logo-1.png" />
      <AuthSection />
    </Layout>
  )
}
